import React from "react"
import { useSelector } from "react-redux"
import { Row, Col } from "react-bootstrap"

import {
    PROVEN_NO, PROVEN_IN_USE, PRIOR_USE,
    LOW_DEMAND_MODE, HIGH_DEMAND_MODE, CONTINUOUS_MODE,
} from "const"
import { StoreType } from "client/store"
import {
    PageForm,
    FormGroup,
    Label,
    Collapse,
} from "client/components"

import FormatScientific from "client/pages/sil/format/scientific"
import { getSilMode } from "client/pages/sil/formulas"

const Form = () => {
    const device = useSelector((state: StoreType) => state.silDevice.deviceView)
    const lang = useSelector((state: StoreType) => state.system.lang)

    const mode = getSilMode(device)
    let modeTitle = ""
    if (mode === LOW_DEMAND_MODE) modeTitle = lang.modeLowDemand
    if (mode === HIGH_DEMAND_MODE) modeTitle = lang.modeHighDemand
    if (mode === CONTINUOUS_MODE) modeTitle = lang.modeContinuous

    return (
        <Collapse show title={lang.deviceDetailsByUser}>
            <PageForm>
                <Row>
                    <Col md={4}>
                        <FormGroup>
                            <Label>{lang.thisDeviceIs}</Label>
                            <div>{lang.deviceType.replace("{0}", device.type)}</div>
                            <div>{lang.deviceMode.replace("{0}", modeTitle)}</div>
                            <div>
                                {device.provenInUse === PROVEN_NO && lang.notProvenInUse}
                                {device.provenInUse === PROVEN_IN_USE && lang.provenInUse}
                                {device.provenInUse === PRIOR_USE && lang.priorUse}
                            </div>
                            <div>{device.logicSolver ? lang.logicSolverYes : lang.logicSolverNo}</div>
                        </FormGroup>
                    </Col>
                    <Col md={8}>
                        <Label>{lang.deviceDetails}</Label>
                        <FormatScientific title={lang.sdOf} data={device.sd} />
                        <FormatScientific title={lang.suOf} data={device.su} />
                        <FormatScientific title={lang.ddOf} data={device.dd} />
                        <FormatScientific title={lang.duOf} data={device.du} />
                    </Col>
                </Row>
            </PageForm>
        </Collapse>
    )
}
export default Form
